import styled from 'styled-components'
import InputMask from 'react-input-mask'

export const Label = styled.label`
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeights.light};
  font-size: 1.4rem;
  line-height: 1.6rem;
  margin-bottom: 5px;
  transition: color 100ms ease-in-out;
  height: 28px;
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 1;
  margin: 0;
  svg {
    & > .svgFill {
      fill: ${({ theme }) => theme.colors.colors.disabled};
    }
    & > .svgStroke {
      stroke: ${({ theme }) => theme.colors.backgrounds.disabled};
    }
  }
  ${({ hours, theme }) => hours && `
    left: 23px;
    cursor: pointer;
    svg {
      & > .svgFill {
        fill: ${theme.colors.colors.redisign.default};
      }
    }
  `}
  ${({ minutes, theme }) => minutes && `
    left: auto;
    right: 5px;
    cursor: pointer;
    svg {
      & > .svgFill {
        fill: ${theme.colors.colors.redisign.default};
      }
    }
  `}
`

export const Error = styled.div`
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.fontWeights.light};
  color: ${({ theme }) => theme.colors.colors.disabled};
  font-size: 1.2rem;
  line-height: 1.4rem;
  width: 100%;
  margin-top: 5px;
  transition: color 100ms ease-in-out;
  text-align: left;
  word-break: break-word;
`

export const EnumerationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  flex-direction: column;
  align-items: center;
  min-width: 10px;
  max-width: 10px;
  & svg {
    margin: 3px 0 3px 0 !important;
  }
`

export const FieldStyled = styled(InputMask)`
  outline: none;
  background: ${({ theme }) => theme.colors.backgrounds.textField};
  border: 0px solid ${({ theme }) => theme.colors.borders.textField};
  -webkit-text-fill-color: ${({ theme }) => theme.colors.colors.textField};
  color: ${({ theme }) => theme.colors.colors.textField};
  width: 50%;
  height: 28px;
  font-size: 1.4rem;
  line-height: 2rem;
  padding-left: 3px;
  ${({ first }) => first && `
    padding-left: 5px;
  `}
  transition: background 100ms ease-in-out;

  ::placeholder {
    color: ${({ theme }) => theme.colors.colors.textField};
  }

  :disabled {
    border: ${({ theme }) => `1px solid ${theme.colors.backgrounds.textFieldDisabled}`};
    background: ${({ theme }) => theme.colors.backgrounds.textFieldDisabled};
    box-shadow: ${({ theme }) => theme.colors.shadows.field};
  }

  &[type=number]::-webkit-inner-spin-button, 
  &[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }
`

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TextFieldStyled = styled.div`
  min-width: 73px;
  max-width: 73px;
  display: flex;
  align-items: flex-start;
  position: relative;
  border-radius: 4px;
  border: 1px solid ${({ theme, isError }) => (isError
    ? theme.colors.messages.error
    : theme.colors.borders.textField)};
  display: flex;

  ${ControlsContainer} {
    height: 28px;
    position: absolute;
    right: 0px;
    top: 5px;
    svg {
      & > .svgFill {
        fill: ${({ theme }) => theme.colors.colors.redisign.dark};
      }
      & > .svgStroke {
        stroke: ${({ theme }) => theme.colors.colors.redisign.dark};
      }
    }
  }

  ${FieldStyled} {
    ${({ dark, theme }) => dark && `
      background: ${theme.colors.backgrounds.default};
      border-color: ${theme.colors.borders.default};
    `}
  }

  ${({ fieldIcon }) => fieldIcon && `
    ${FieldStyled} {
      padding-left: 33px;
    }
  `}

  ${({ resetButton }) => resetButton && `
    ${FieldStyled} {
      padding-right: 33px;
    }
  `}

  ${FieldStyled} {
    background: ${({ theme }) => theme.colors.backgrounds.textFieldActive};
    -webkit-text-fill-color: ${({ theme }) => theme.colors.colors.textFieldActive};
    color: ${({ theme }) => theme.colors.colors.textFieldActive};
  }

  ${({ disabled, theme, isError, dark }) => (disabled && !dark) && `
    ${FieldStyled} {
      border: 1px solid
      ${isError ? theme.colors.messages.error : theme.colors.backgrounds.textFieldDisabled};
      background: ${theme.colors.backgrounds.textFieldDisabled};
    }
  `}
`
